/*
 *
 * RTM resolver constants
 *
 */

// API layer constants for activity

/** TO BE DEPRECATED */
export const RTM_WORKSPACE_ACTIVITY_PUBLISH = 'workspace.activity.publish';
export const RTM_WORKSPACE_ACTIVITY_PUBLISH_OK = 'workspace.activity.publish.ok';
export const RTM_WORKSPACE_ACTIVITY_PUBLISH_ERROR = 'workspace.activity.publish.error';

export const RTM_AUTHOR_ACTIVITY_CREATE = 'author.activity.create';
export const RTM_AUTHOR_ACTIVITY_CREATE_OK = 'author.activity.create.ok';
export const RTM_AUTHOR_ACTIVITY_CREATE_ERROR = 'author.activity.create.error';

export const RTM_AUTHOR_ACTIVITY_GET = 'author.activity.get';
export const RTM_AUTHOR_ACTIVITY_GET_OK = 'author.activity.get.ok';
export const RTM_AUTHOR_ACTIVITY_GET_ERROR = 'author.activity.get.error';

export const RTM_AUTHOR_ELEMENT_EXPORT_REQUEST = 'author.element.export.request';
export const RTM_AUTHOR_ELEMENT_EXPORT_REQUEST_OK = 'author.element.export.request.ok';
export const RTM_AUTHOR_ELEMENT_EXPORT_REQUEST_ERROR = 'author.element.export.request.error';
export const RTM_PRE_SIGNED_URL_REQUEST = 'pre.signed.url.request';
export const RTM_PRE_SIGNED_URL_REQUEST_OK = 'pre.signed.url.request.ok';
export const RTM_PRE_SIGNED_URL_REQUEST_ERROR = 'pre.signed.url.request.error';
export const RTM_AUTHOR_ELEMENT_EXPORT_TYPE_PREVIEW = 'EPUB_PREVIEW';
export const RTM_AUTHOR_ELEMENT_EXPORT_TYPE_REPORT = 'EPUB_PREFLIGHT_CHECK';
export const RTM_AUTHOR_ELEMENT_EXPORT_TYPE_CP_REPORT = 'EPUB_CP_PREFLIGHT_CHECK';
export const RTM_AUTHOR_ELEMENT_EXPORT_TYPE_ETEXT = 'EPUB_PUBLISH';
export const RTM_AUTHOR_ELEMENT_EXPORT_TYPE_PPLUS = 'BRONTE_VIEWER';
export const RTM_AUTHOR_ELEMENT_EXPORT_TYPE_PPLUS_TEST = 'BRONTE_VIEWER_TEST_ONLY';
export const RTM_AUTHOR_ELEMENT_EXPORT_TYPE_CHANNEL_PARTNER = 'EPUB_CP_PUBLISH';
export const RTM_AUTHOR_ELEMENT_EXPORT_TYPE_INDESIGN = 'IN_DESIGN_PUBLISH';
export const MIGRATE_ETEXT_TO_BV = 'MIGRATE_ETEXT_TO_BV';

export const RTM_PUBLICATION_CLASS_ON_DEMAND_PUBLISH_REQUEST = 'publication.classondemand.publish.request';
export const RTM_PUBLICATION_CLASS_ON_DEMAND_PUBLISH_REQUEST_OK = 'publication.classondemand.publish.request.ok';
export const RTM_PUBLICATION_CLASS_ON_DEMAND_PUBLISH_REQUEST_ERROR = 'publication.classondemand.publish.request.error';

export const RTM_PUBLICATION_PEARSON_PLUS_PUBLISH_REQUEST = 'publication.pearsonplus.publish.request';
export const RTM_PUBLICATION_PEARSON_PLUS_PUBLISH_REQUEST_OK = 'publication.pearsonplus.publish.request.ok';
export const RTM_PUBLICATION_PEARSON_PLUS_PUBLISH_REQUEST_ERROR = 'publication.pearsonplus.publish.request.error';

export const RTM_PUBLICATION_COURSEWARE_STATUS = 'publication.courseware.status';
export const RTM_PUBLICATION_COURSEWARE_STATUS_OK = 'publication.courseware.status.ok';
export const RTM_PUBLICATION_COURSEWARE_STATUS_ERROR = 'publication.courseware.status.error';

export const RTM_IS_ELEMENT_PUBLISHED = 'is.element.published';
export const RTM_IS_ELEMENT_PUBLISHED_OK = 'is.element.published.ok';
export const RTM_IS_ELEMENT_PUBLISHED_ERROR = 'is.element.published.error';

export const RTM_AUTHOR_EXPORT_SUBSCRIBE = 'author.export.subscribe';
export const RTM_AUTHOR_EXPORT_SUBSCRIBE_OK = 'author.export.subscribe.ok';
export const RTM_AUTHOR_EXPORT_SUBSCRIBE_ERROR = 'author.export.subscribe.error';

export const RTM_AUTHOR_EXPORT_UNSUBSCRIBE = 'author.export.unsubscribe';
export const RTM_AUTHOR_EXPORT_UNSUBSCRIBE_OK = 'author.export.unsubscribe.ok';
export const RTM_AUTHOR_EXPORT_UNSUBSCRIBE_ERROR = 'author.export.unsubscribe.error';

export const RTM_AUTHOR_ACTIVITY_SUBSCRIBE = 'author.activity.subscribe';
export const RTM_AUTHOR_ACTIVITY_SUBSCRIBE_OK = 'author.activity.subscribe.ok';
export const RTM_AUTHOR_ACTIVITY_SUBSCRIBE_ERROR = 'author.activity.subscribe.error';

export const RTM_AUTHOR_ACTIVITY_UNSUBSCRIBE = 'author.activity.unsubscribe';
export const RTM_AUTHOR_ACTIVITY_UNSUBSCRIBE_OK = 'author.activity.unsubscribe.ok';
export const RTM_AUTHOR_ACTIVITY_UNSUBSCRIBE_ERROR = 'author.activity.unsubscribe.error';

export const RTM_WORKSPACE_PROJECT_SUBSCRIBE = 'workspace.project.subscribe';
export const RTM_WORKSPACE_PROJECT_SUBSCRIBE_OK = 'workspace.project.subscribe.ok';
export const RTM_WORKSPACE_PROJECT_SUBSCRIBE_ERROR = 'workspace.project.subscribe.error';

export const RTM_WORKSPACE_PROJECT_UNSUBSCRIBE = 'workspace.project.unsubscribe';
export const RTM_WORKSPACE_PROJECT_UNSUBSCRIBE_OK = 'workspace.project.unsubscribe.ok';
export const RTM_WORKSPACE_PROJECT_UNSUBSCRIBE_ERROR = 'workspace.project.unsubscribe.error';

export const RTM_AUTHOR_ACTIVITY_CONFIG_REPLACE = 'author.activity.config.replace';
export const RTM_AUTHOR_ACTIVITY_CONFIG_REPLACE_OK = 'author.activity.config.replace.ok';
export const RTM_AUTHOR_ACTIVITY_CONFIG_REPLACE_ERROR = 'author.activity.config.replace.error';

export const RTM_AUTHOR_ACTIVITY_DUPLICATE = 'author.activity.duplicate';
export const RTM_AUTHOR_ACTIVITY_DUPLICATE_OK = 'author.activity.duplicate.ok';
export const RTM_AUTHOR_ACTIVITY_DUPLICATE_ERROR = 'author.activity.duplicate.error';

export const RTM_AUTHOR_ACTIVITY_DELETE = 'author.activity.delete';
export const RTM_AUTHOR_ACTIVITY_DELETE_OK = 'author.activity.delete.ok';
export const RTM_AUTHOR_ACTIVITY_DELETE_ERROR = 'author.activity.delete.error';

export const RTM_AUTHOR_ACTIVITY_THEME_REPLACE = 'author.activity.theme.replace';
export const RTM_AUTHOR_ACTIVITY_THEME_REPLACE_OK = 'author.activity.theme.replace.ok';
export const RTM_AUTHOR_ACTIVITY_THEME_REPLACE_ERROR = 'author.activity.theme.replace.error';

export const RTM_AUTHOR_ACTIVITY_ICON_LIBRARY_ASSOCIATE = 'author.activity.icon.library.associate';
export const RTM_AUTHOR_ACTIVITY_ICON_LIBRARY_ASSOCIATE_OK = 'author.activity.icon.library.associate.ok';
export const RTM_AUTHOR_ACTIVITY_ICON_LIBRARY_ASSOCIATE_ERROR = 'author.activity.icon.library.associate.error';

export const RTM_AUTHOR_ACTIVITY_MOVE = 'author.activity.move';
export const RTM_AUTHOR_ACTIVITY_MOVE_OK = 'author.activity.move.ok';
export const RTM_AUTHOR_ACTIVITY_MOVE_ERROR = 'author.activity.move.error';

export const RTM_AUTHOR_ACTIVITY_PLUGIN_GET = 'author.activity.plugin.get';
export const RTM_AUTHOR_ACTIVITY_PLUGIN_GET_OK = 'author.activity.plugin.get.ok';
export const RTM_AUTHOR_ACTIVITY_PLUGIN_GET_ERROR = 'author.activity.plugin.get.error';


// API layer constants for pathway

export const RTM_AUTHOR_PATHWAY_CREATE = 'author.pathway.create';
export const RTM_AUTHOR_PATHWAY_CREATE_OK = 'author.pathway.create.ok';
export const RTM_AUTHOR_PATHWAY_CREATE_ERROR = 'author.pathway.create.error';

export const RTM_AUTHOR_PATHWAY_DELETE = 'author.pathway.delete';
export const RTM_AUTHOR_PATHWAY_DELETE_OK = 'author.pathway.delete.ok';
export const RTM_AUTHOR_PATHWAY_DELETE_ERROR = 'author.pathway.delete.error';

export const RTM_AUTHOR_PATHWAY_GET = 'author.pathway.get';
export const RTM_AUTHOR_PATHWAY_GET_OK = 'author.pathway.get.ok';
export const RTM_AUTHOR_PATHWAY_GET_ERROR = 'author.pathway.get.error';

export const RTM_AUTHOR_PATHWAY_WALKABLE_REORDER = 'author.pathway.walkable.reorder';
export const RTM_AUTHOR_PATHWAY_WALKABLE_REORDER_OK = 'author.pathway.walkable.reorder.ok';
export const RTM_AUTHOR_PATHWAY_WALKABLE_REORDER_ERROR = 'author.pathway.walkable.reorder.error';

export const RTM_AUTHOR_PATHWAY_CONFIG_REPLACE = 'author.pathway.config.replace';
export const RTM_AUTHOR_PATHWAY_CONFIG_REPLACE_OK = 'author.pathway.config.replace.ok';
export const RTM_AUTHOR_PATHWAY_CONFIG_REPLACE_ERROR = 'author.pathway.config.replace.error';

// API layer constants for scenario

export const RTM_AUTHOR_SCENARIO_CREATE = 'author.scenario.create';
export const RTM_AUTHOR_SCENARIO_CREATE_OK = 'author.scenario.create.ok';
export const RTM_AUTHOR_SCENARIO_CREATE_ERROR = 'author.scenario.create.error';

export const RTM_AUTHOR_SCENARIO_LIST = 'author.scenario.list';
export const RTM_AUTHOR_SCENARIO_LIST_OK = 'author.scenario.list.ok';
export const RTM_AUTHOR_SCENARIO_LIST_ERROR = 'author.scenario.list.error';

export const RTM_AUTHOR_SCENARIO_REPLACE = 'author.scenario.replace';
export const RTM_AUTHOR_SCENARIO_REPLACE_OK = 'author.scenario.replace.ok';
export const RTM_AUTHOR_SCENARIO_REPLACE_ERROR = 'author.scenario.replace.error';

export const RTM_AUTHOR_SCENARIOS_REORDER = 'author.scenarios.reorder';
export const RTM_AUTHOR_SCENARIOS_REORDER_OK = 'author.scenarios.reorder.ok';
export const RTM_AUTHOR_SCENARIOS_REORDER_ERROR = 'author.scenarios.reorder.error';

export const RTM_AUTHOR_SCENARIOS_TEST = 'author.interactive.scenarios.test';
export const RTM_AUTHOR_SCENARIOS_TEST_OK = 'author.interactive.scenarios.test.ok';
export const RTM_AUTHOR_SCENARIOS_TEST_ERROR = 'author.interactive.scenarios.test.error';

// API layer constants for plugin

export const RTM_AUTHOR_PLUGIN_GET = 'author.plugin.get';
export const RTM_AUTHOR_PLUGIN_GET_OK = 'author.plugin.get.ok';
export const RTM_AUTHOR_PLUGIN_GET_ERROR = 'author.plugin.get.error';

export const RTM_AUTHOR_PLUGIN_LIST = 'author.plugin.list';
export const RTM_AUTHOR_PLUGIN_LIST_OK = 'author.plugin.list.ok';
export const RTM_AUTHOR_PLUGIN_LIST_ERROR = 'author.plugin.list.error';

export const RTM_AUTHOR_EDIT_ACTIVE = 'author.edit.active';
export const RTM_AUTHOR_EDIT_ACTIVE_OK = 'author.edit.active.ok';
export const RTM_AUTHOR_EDIT_ACTIVE_ERROR = 'author.edit.active.error';

export const RTM_AUTHOR_EDIT_RELEASE = 'author.edit.release';
export const RTM_AUTHOR_EDIT_RELEASE_OK = 'author.edit.release.ok';
export const RTM_AUTHOR_EDIT_RELEASE_ERROR = 'author.edit.release.error';

// API layer constants for assets

export const RTM_AUTHOR_ASSET_GET = 'author.asset.get';
export const RTM_AUTHOR_ASSET_GET_OK = 'author.asset.get.ok';
export const RTM_AUTHOR_ASSET_GET_ERROR = 'author.asset.get.error';

export const RTM_AUTHOR_COURSEWARE_ASSET_ADD = 'author.courseware.asset.add';
export const RTM_AUTHOR_COURSEWARE_ASSET_ADD_OK = 'author.courseware.asset.add.ok';
export const RTM_AUTHOR_COURSEWARE_ASSET_ADD_ERROR = 'author.courseware.asset.add.error';

export const RTM_AUTHOR_COURSEWARE_ASSET_REMOVE = 'author.courseware.asset.remove';
export const RTM_AUTHOR_COURSEWARE_ASSET_REMOVE_OK = 'author.courseware.asset.remove.ok';
export const RTM_AUTHOR_COURSEWARE_ASSET_REMOVE_ERROR = 'author.courseware.asset.remove.error';

export const RTM_AUTHOR_ASSET_CREATE = 'author.asset.create';
export const RTM_AUTHOR_ASSET_CREATE_OK = 'author.asset.create.ok';
export const RTM_AUTHOR_ASSET_CREATE_ERROR = 'author.asset.create.error';

export const RTM_AUTHOR_ICON_ASSET_LIST = 'author.icon.asset.list';
export const RTM_AUTHOR_ICON_ASSET_LIST_OK = 'author.icon.asset.list.ok';
export const RTM_AUTHOR_ICON_ASSET_LIST_ERROR = 'author.icon.asset.list.error';

// API layer constants for InteractiveResolver

export const RTM_AUTHOR_INTERACTIVE_CREATE = 'author.interactive.create';
export const RTM_AUTHOR_INTERACTIVE_CREATE_OK = 'author.interactive.create.ok';
export const RTM_AUTHOR_INTERACTIVE_CREATE_ERROR = 'author.interactive.create.error';

export const RTM_AUTHOR_INTERACTIVE_GET = 'author.interactive.get';
export const RTM_AUTHOR_INTERACTIVE_GET_OK = 'author.interactive.get.ok';
export const RTM_AUTHOR_INTERACTIVE_GET_ERROR = 'author.interactive.get.error';

export const RTM_AUTHOR_INTERACTIVE_DELETE = 'author.interactive.delete';
export const RTM_AUTHOR_INTERACTIVE_DELETE_OK = 'author.interactive.delete.ok';
export const RTM_AUTHOR_INTERACTIVE_DELETE_ERROR = 'author.interactive.delete.error';

export const RTM_AUTHOR_INTERACTIVE_DUPLICATE = 'author.interactive.duplicate';
export const RTM_AUTHOR_INTERACTIVE_DUPLICATE_OK = 'author.interactive.duplicate.ok';
export const RTM_AUTHOR_INTERACTIVE_DUPLICATE_ERROR = 'author.interactive.duplicate.error';

export const RTM_AUTHOR_COMPONENTS_MOVE = 'author.components.move';
export const RTM_AUTHOR_COMPONENTS_MOVE_OK = 'author.components.move.ok';
export const RTM_AUTHOR_COMPONENTS_ERROR = 'author.components.move.error';

export const RTM_AUTHOR_INTERACTIVE_MOVE = 'author.interactive.move';
export const RTM_AUTHOR_INTERACTIVE_MOVE_OK = 'author.interactive.move.ok';
export const RTM_AUTHOR_INTERACTIVE_MOVE_ERROR = 'author.interactive.move.error';

export const RTM_AUTHOR_INTERACTIVE_CONFIG_REPLACE = 'author.interactive.config.replace';
export const RTM_AUTHOR_INTERACTIVE_CONFIG_REPLACE_OK = 'author.interactive.config.replace.ok';
export const RTM_AUTHOR_INTERACTIVE_CONFIG_REPLACE_ERROR = 'author.interactive.config.replace.error';

export const RTM_AUTHOR_STUDENT_SCOPE_REGISTER = 'author.student.scope.register';
export const RTM_AUTHOR_STUDENT_SCOPE_REGISTER_OK = 'author.student.scope.register.ok';
export const RTM_AUTHOR_STUDENT_SCOPE_REGISTER_ERROR = 'author.student.scope.register.error';

export const RTM_AUTHOR_STUDENT_SCOPE_DEREGISTER = 'author.student.scope.deregister';
export const RTM_AUTHOR_STUDENT_SCOPE_DEREGISTER_OK = 'author.student.scope.deregister.ok';
export const RTM_AUTHOR_STUDENT_SCOPE_DEREGISTER_ERROR = 'author.student.scope.deregister.error';

export const RTM_COURSEWARE_ELEMENT_CONDITIONAL_ADD = 'courseware.element.conditional.add';
export const RTM_COURSEWARE_ELEMENT_CONDITIONAL_ADD_OK = 'courseware.element.conditional.add.ok';
export const RTM_COURSEWARE_ELEMENT_CONDITIONAL_ADD_ERROR = 'courseware.element.conditional.add.error';

export const RTM_COURSEWARE_ELEMENT_CONDITIONAL_REMOVE = 'courseware.element.conditional.remove';
export const RTM_COURSEWARE_ELEMENT_CONDITIONAL_REMOVE_OK = 'courseware.element.conditional.remove.ok';
export const RTM_COURSEWARE_ELEMENT_CONDITIONAL_REMOVE_ERROR = 'courseware.element.conditional.remove.error';

// API layer constants for ComponentResolver RTM_AUTHOR_ACTIVITY_COMPONENT_

export const RTM_AUTHOR_ACTIVITY_COMPONENT_CREATE = 'author.activity.component.create';
export const RTM_AUTHOR_ACTIVITY_COMPONENT_CREATE_OK = 'author.activity.component.create.ok';
export const RTM_AUTHOR_ACTIVITY_COMPONENT_CREATE_ERROR = 'author.activity.component.create.error';

export const RTM_AUTHOR_ACTIVITY_COMPONENT_DELETE = 'author.activity.component.delete';
export const RTM_AUTHOR_ACTIVITY_COMPONENT_DELETE_OK = 'author.activity.component.delete.ok';
export const RTM_AUTHOR_ACTIVITY_COMPONENT_DELETE_ERROR = 'author.activity.component.delete.error';

export const RTM_AUTHOR_INTERACTIVE_COMPONENT_CREATE = 'author.interactive.component.create';
export const RTM_AUTHOR_INTERACTIVE_COMPONENT_CREATE_OK = 'author.interactive.component.create.ok';
export const RTM_AUTHOR_INTERACTIVE_COMPONENT_CREATE_ERROR = 'author.interactive.component.create.error';

export const RTM_AUTHOR_INTERACTIVE_COMPONENT_DELETE = 'author.interactive.component.delete';
export const RTM_AUTHOR_INTERACTIVE_COMPONENT_DELETE_OK = 'author.interactive.component.delete.ok';
export const RTM_AUTHOR_INTERACTIVE_COMPONENT_DELETE_ERROR = 'author.interactive.component.delete.error';

export const RTM_AUTHOR_INTERACTIVE_COMPONENTS_DELETE = 'author.interactive.components.delete';
export const RTM_AUTHOR_INTERACTIVE_COMPONENTS_DELETE_OK = 'author.interactive.components.delete.ok';
export const RTM_AUTHOR_INTERACTIVE_COMPONENTS_DELETE_ERROR = 'author.interactive.components.delete.error';

export const RTM_AUTHOR_INTERACTIVE_COMPONENT_RESTORE = 'author.interactive.component.restore';
export const RTM_AUTHOR_INTERACTIVE_COMPONENT_RESTORE_OK = 'author.interactive.component.restore.ok';
export const RTM_AUTHOR_INTERACTIVE_COMPONENT_RESTORE_ERROR = 'author.interactive.component.restore.error';

export const RTM_AUTHOR_COMPONENT_GET = 'author.component.get';
export const RTM_AUTHOR_COMPONENT_GET_OK = 'author.component.get.ok';
export const RTM_AUTHOR_COMPONENT_GET_ERROR = 'author.component.get.error';

export const RTM_AUTHOR_COMPONENT_CONFIG_REPLACE = 'author.component.replace';
export const RTM_AUTHOR_COMPONENT_CONFIG_REPLACE_OK = 'author.component.replace.ok';
export const RTM_AUTHOR_COMPONENT_CONFIG_REPLACE_ERROR = 'author.component.replace.error';

export const RTM_AUTHOR_ALFRESCO_SYNC = 'author.alfresco.assets.sync';
export const RTM_AUTHOR_ALFRESCO_SYNC_OK = 'author.alfresco.assets.sync.ok';
export const RTM_AUTHOR_ALFRESCO_SYNC_ERROR = 'author.alfresco.assets.sync.error';

export const RTM_AUTHOR_ASSET_ALFRESCO_SELECT = 'author.asset.alfresco.select';
export const RTM_AUTHOR_ASSET_ALFRESCO_SELECT_OK = 'author.asset.alfresco.select.ok';
export const RTM_AUTHOR_ASSET_ALFRESCO_SELECT_ERROR = 'author.asset.alfresco.select.error';

export const RTM_AUTHOR_ALFRESCO_ASSETS_PUSH = 'author.alfresco.assets.push';
export const RTM_AUTHOR_ALFRESCO_ASSETS_PUSH_OK = 'author.alfresco.assets.push.ok';
export const RTM_AUTHOR_ALFRESCO_ASSETS_PUSH_ERROR = 'author.alfresco.assets.push.error';

export const RTM_AUTHOR_ALFRESCO_ASSETS_PUSH_COUNT = 'author.alfresco.assets.push.count';
export const RTM_AUTHOR_ALFRESCO_ASSETS_PUSH_COUNT_OK = 'author.alfresco.assets.push.count.ok';
export const RTM_AUTHOR_ALFRESCO_ASSETS_PUSH_COUNT_ERROR = 'author.alfresco.assets.push.count.error';

export const RTM_AUTHOR_ALFRESCO_ASSETS_PROGRESS = 'author.alfresco.assets.progress';
export const RTM_AUTHOR_ALFRESCO_ASSETS_PROGRESS_OK = 'author.alfresco.assets.progress.ok';
export const RTM_AUTHOR_ALFRESCO_ASSETS_PROGRESS_ERROR = 'author.alfresco.assets.progress.error';

// API layer constants for courseware breadcrumbs (both ActivityResolver, and InteractiveResolver)

export const RTM_AUTHOR_COURSEWARE_BREADCRUMB = 'author.courseware.breadcrumb';
export const RTM_AUTHOR_COURSEWARE_BREADCRUMB_OK = 'author.courseware.breadcrumb.ok';
export const RTM_AUTHOR_COURSEWARE_BREADCRUMB_ERROR = 'author.courseware.breadcrumb.error';

export const RTM_PROJECT_ACTIVITY_CREATE = 'project.activity.create';
export const RTM_PROJECT_ACTIVITY_CREATE_OK = 'project.activity.create.ok';
export const RTM_PROJECT_ACTIVITY_CREATE_ERROR = 'project.activity.create.error';

export const RTM_PROJECT_ACTIVITY_LIST = 'project.activity.list';
export const RTM_PROJECT_ACTIVITY_LIST_OK = 'project.activity.list.ok';
export const RTM_PROJECT_ACTIVITY_LIST_ERROR = 'project.activity.list.error';

export const RTM_WORKSPACE_PROJECT_LIST = 'workspace.project.list';
export const RTM_WORKSPACE_PROJECT_LIST_OK = 'workspace.project.list.ok';
export const RTM_WORKSPACE_PROJECT_LIST_ERROR = 'workspace.project.list.error';

export const RTM_WORKSPACE_PROJECT_GET = 'workspace.project.get';
export const RTM_WORKSPACE_PROJECT_GET_OK = 'workspace.project.get.ok';
export const RTM_WORKSPACE_PROJECT_GET_ERROR = 'workspace.project.get.error';

export const RTM_WORKSPACE_PROJECT_COLLABORATOR_SUMMARY = 'workspace.project.collaborator.summary';
export const RTM_WORKSPACE_PROJECT_COLLABORATOR_SUMMARY_OK = 'workspace.project.collaborator.summary.ok';
export const RTM_WORKSPACE_PROJECT_COLLABORATOR_SUMMARY_ERROR = 'workspace.project.collaborator.summary.error';

export const RTM_WORKSPACE_PROJECT_PERMISSION_GRANT = 'workspace.project.permission.grant';
export const RTM_WORKSPACE_PROJECT_PERMISSION_GRANT_OK = 'workspace.project.permission.grant.ok';
export const RTM_WORKSPACE_PROJECT_PERMISSION_GRANT_ERROR = 'workspace.project.permission.grant.error';

export const RTM_WORKSPACE_PROJECT_PERMISSION_REVOKE = 'workspace.project.permission.revoke';
export const RTM_WORKSPACE_PROJECT_PERMISSION_REVOKE_OK = 'workspace.project.permission.revoke.ok';
export const RTM_WORKSPACE_PROJECT_PERMISSION_REVOKE_ERROR = 'workspace.project.permission.revoke.error';

export const RTM_WORKSPACE_PROJECT_DELETE = 'workspace.project.delete';
export const RTM_WORKSPACE_PROJECT_DELETE_OK = 'workspace.project.delete.ok';
export const RTM_WORKSPACE_PROJECT_DELETE_ERROR = 'workspace.project.delete.error';

export const RTM_WORKSPACE_PROJECT_MOVE = 'workspace.project.move';
export const RTM_WORKSPACE_PROJECT_MOVE_OK = 'workspace.project.move.ok';
export const RTM_WORKSPACE_PROJECT_MOVE_ERROR = 'workspace.project.move.error';

export const RTM_WORKSPACE_PROJECT_REPLACE = 'workspace.project.replace';
export const RTM_WORKSPACE_PROJECT_REPLACE_OK = 'workspace.project.replace.ok';
export const RTM_WORKSPACE_PROJECT_REPLACE_ERROR = 'workspace.project.replace.error';

export const RTM_WORKSPACE_PROJECT_SETTINGS_GET = 'workspace.project.settings';
export const RTM_WORKSPACE_PROJECT_SETTINGS_OK = 'workspace.project.settings.ok';
export const RTM_WORKSPACE_PROJECT_SETTINGS_ERROR = 'workspace.project.settings.error';

export const RTM_WORKSPACE_PROJECT_SETTINGS_SAVE = 'workspace.project.settings.save';
export const RTM_WORKSPACE_PROJECT_SETTINGS_SAVE_OK = 'workspace.project.settings.save.ok';
export const RTM_WORKSPACE_PROJECT_SETTINGS_SAVE_ERROR = 'workspace.project.settings..saveerror';

export const RTM_WORKSPACE_COURSEWARE_CONDITIONAL_GET = 'courseware.course.conditional.get';
export const RTM_WORKSPACE_COURSEWARE_CONDITIONAL_GET_OK = 'courseware.course.conditional.get.ok';
export const RTM_WORKSPACE_COURSEWARE_CONDITIONAL_GET_ERROR = 'courseware.course.conditional.get.error';

export const RTM_WORKSPACE_COURSEWARE_LANGUAGE_GET = 'courseware.course.language.get';
export const RTM_WORKSPACE_COURSEWARE_LANGUAGE_GET_OK = 'courseware.course.language.get.ok';
export const RTM_WORKSPACE_COURSEWARE_LANGUAGE_GET_ERROR = 'courseware.course.language.get.error';

export const RTM_WORKSPACE_COURSEWARE_CONDITIONAL_ADD = 'courseware.course.conditional.add';
export const RTM_WORKSPACE_COURSEWARE_CONDITIONAL_ADD_OK = 'courseware.course.conditional.add.ok';
export const RTM_WORKSPACE_COURSEWARE_CONDITIONAL_ADD_ERROR = 'courseware.course.conditional.add.error';

export const RTM_WORKSPACE_COURSEWARE_LANGUAGE_ADD = 'courseware.course.language.add';
export const RTM_WORKSPACE_COURSEWARE_LANGUAGE_ADD_OK = 'courseware.course.language.add.ok';
export const RTM_WORKSPACE_COURSEWARE_LANGUAGE_ADD_ERROR = 'courseware.course.language.add.error';

export const RTM_WORKSPACE_COURSEWARE_LANGUAGE_TRANSLATE = 'author.translation.sqs';
export const RTM_WORKSPACE_COURSEWARE_LANGUAGE_TRANSLATE_OK = 'author.translation.sqs.ok';
export const RTM_WORKSPACE_COURSEWARE_LANGUAGE_TRANSLATE_ERROR = 'author.translation.sqs.error';


export const RTM_PROJECT_ACTIVITY_DUPLICATE = 'project.activity.duplicate';
export const RTM_PROJECT_ACTIVITY_DUPLICATE_OK = 'project.activity.duplicate.ok';
export const RTM_PROJECT_ACTIVITY_DUPLICATE_ERROR = 'project.activity.duplicate.error';

export const RTM_USER_FAVORITE_CREATE = 'user.content.favorite.create';
export const RTM_USER_FAVORITE_CREATE_OK = 'user.content.favorite.create.ok';
export const RTM_USER_FAVORITE_CREATE_ERROR = 'user.content.favorite.create.error';

export const RTM_USER_FAVORITE_REMOVE = 'user.content.favorite.remove';
export const RTM_USER_FAVORITE_REMOVE_OK = 'user.content.favorite.remove.ok';
export const RTM_USER_FAVORITE_REMOVE_ERROR = 'user.content.favorite.remove.error';

export const RTM_GET_USER_FAVORITE = 'user.content.favorite.get';
export const RTM_GET_USER_FAVORITE_OK = 'user.content.favorite.get.ok';
export const RTM_GET_USER_FAVORITE_ERROR = 'user.content.favorite.get.error';

export const RTM_GET_USER_RECENT_VIEWED = 'user.content.recently.viewed.get';
export const RTM_GET_USER_RECENT_VIEWED_OK = 'user.content.recently.viewed.get.ok';
export const RTM_GET_USER_RECENT_VIEWED_ERROR = 'user.content.recently.viewed.get.error';

export const RTM_PROJECT_ACTIVITY_DELETE = 'project.activity.delete';
export const RTM_PROJECT_ACTIVITY_DELETE_OK = 'project.activity.delete.ok';
export const RTM_PROJECT_ACTIVITY_DELETE_ERROR = 'project.activity.delete.error';

export const RTM_PROJECT_ACTIVITY_PUBLISH = 'project.activity.publish';
export const RTM_PROJECT_ACTIVITY_PUBLISH_OK = 'project.activity.publish.ok';
export const RTM_PROJECT_ACTIVITY_PUBLISH_ERROR = 'project.activity.publish.error';

export const RTM_PROJECT_EXPORT_LIST = 'project.export.list';
export const RTM_PROJECT_EXPORT_LIST_OK = 'project.export.list.ok';
export const RTM_PROJECT_EXPORT_LIST_ERROR = 'project.export.list.error';

// API Layer constants for ingestion
export const RTM_PROJECT_INGEST_CREATE = 'project.ingest.create';
export const RTM_PROJECT_INGEST_CREATE_OK = 'project.ingest.create.ok';
export const RTM_PROJECT_INGEST_CREATE_ERROR = 'project.ingest.create.error';

export const RTM_PROJECT_INGEST_LOG_LIST = 'project.ingest.log.list';
export const RTM_PROJECT_INGEST_LOG_LIST_OK = 'project.ingest.log.list.ok';
export const RTM_PROJECT_INGEST_LOG_LIST_ERROR = 'project.ingest.log.list.error';

export const RTM_PROJECT_INGEST_START = 'project.ingest.start';
export const RTM_PROJECT_INGEST_START_OK = 'project.ingest.start.ok';
export const RTM_PROJECT_INGEST_START_ERROR = 'project.ingest.start.error';

export const RTM_PROJECT_INGEST_UPDATE = 'project.ingest.update';
export const RTM_PROJECT_INGEST_UPDATE_OK = 'project.ingest.update.ok';
export const RTM_PROJECT_INGEST_UPDATE_ERROR = 'project.ingest.update.error';

export const RTM_PROJECT_INGEST_DELETE = 'project.ingest.delete';
export const RTM_PROJECT_INGEST_DELETE_OK = 'project.ingest.delete.ok';
export const RTM_PROJECT_INGEST_DELETE_ERROR = 'project.ingest.delete.error';

export const RTM_PROJECT_INGESTION_ROOT_GET = 'project.ingestion.root.get';
export const RTM_PROJECT_INGESTION_ROOT_GET_OK = 'project.ingestion.root.get.ok';
export const RTM_PROJECT_INGESTION_ROOT_GET_ERROR = 'project.ingestion.root.get.error';

export const RTM_PROJECT_INGEST_GET = 'project.ingest.get';
export const RTM_PROJECT_INGEST_GET_OK = 'project.ingest.get.ok';
export const RTM_PROJECT_INGEST_GET_ERROR = 'project.ingest.get.error';

// API Layer constants for annotations
export const RTM_AUTHOR_ANNOTATION_LIST = 'author.annotation.list';
export const RTM_AUTHOR_ANNOTATION_LIST_OK = 'author.annotation.list.ok';
export const RTM_AUTHOR_ANNOTATION_LIST_ERROR = 'author.annotation.list.error';

export const RTM_AUTHOR_ANNOTATION_GET = 'author.annotation.get';
export const RTM_AUTHOR_ANNOTATION_GET_OK = 'author.annotation.get.ok';
export const RTM_AUTHOR_ANNOTATION_GET_ERROR = 'author.annotation.get.error';

export const RTM_AUTHOR_ANNOTATION_READ = 'author.annotation.read';
export const RTM_AUTHOR_ANNOTATION_READ_OK = 'author.annotation.read.ok';
export const RTM_AUTHOR_ANNOTATION_READ_ERROR = 'author.annotation.read.error';

export const RTM_AUTHOR_ANNOTATION_CREATE = 'author.annotation.create';
export const RTM_AUTHOR_ANNOTATION_CREATE_OK = 'author.annotation.create.ok';
export const RTM_AUTHOR_ANNOTATION_CREATE_ERROR = 'author.annotation.create.error';

export const RTM_AUTHOR_ANNOTATION_UPDATE = 'author.annotation.update';
export const RTM_AUTHOR_ANNOTATION_UPDATE_OK = 'author.annotation.update.ok';
export const RTM_AUTHOR_ANNOTATION_UPDATE_ERROR = 'author.annotation.update.error';

export const RTM_AUTHOR_ANNOTATION_RESOLVE = 'author.annotation.resolve';
export const RTM_AUTHOR_ANNOTATION_RESOLVE_OK = 'author.annotation.resolve.ok';
export const RTM_AUTHOR_ANNOTATION_RESOLVE_ERROR = 'author.annotation.resolve.error';

export const RTM_AUTHOR_ANNOTATION_DELETE = 'author.annotation.delete';
export const RTM_AUTHOR_ANNOTATION_DELETE_OK = 'author.annotation.delete.ok';
export const RTM_AUTHOR_ANNOTATION_DELETE_ERROR = 'author.annotation.delete.error';

export const RTM_AUTHOR_ANNOTATIONS_DELETE = 'author.annotations.delete';
export const RTM_AUTHOR_ANNOTATIONS_DELETE_OK = 'author.annotations.delete.ok';
export const RTM_AUTHOR_ANNOTATIONS_DELETE_ERROR = 'author.annotations.delete.error';

export const RTM_AUTHOR_ANNOTATIONS_RESTORE = 'author.annotations.restore';
export const RTM_AUTHOR_ANNOTATIONS_RESTORE_OK = 'author.annotations.restore.ok';
export const RTM_AUTHOR_ANNOTATIONS_RESTORE_ERROR = 'author.annotations.restore.error';

export const RTM_AUTHOR_ANNOTATION_AGGREGATE = 'author.annotation.aggregate';
export const RTM_AUTHOR_ANNOTATION_AGGREGATE_OK = 'author.annotation.aggregate.ok';
export const RTM_AUTHOR_ANNOTATION_AGGREGATE_ERROR = 'author.annotation.aggregate.error';

export const RTM_AUTHOR_COURSEWARE_STRUCTURE_NAVIGATE = 'author.courseware.structure.navigate';
export const RTM_AUTHOR_COURSEWARE_STRUCTURE_NAVIGATE_OK = 'author.courseware.structure.navigate.ok';
export const RTM_AUTHOR_COURSEWARE_STRUCTURE_NAVIGATE_ERROR = 'author.courseware.structure.navigate.error';

export const RTM_AUTHOR_COURSEWARE_PROJECT_FIND = 'author.courseware.project.find';
export const RTM_AUTHOR_COURSEWARE_PROJECT_FIND_OK = 'author.courseware.project.find.ok';
export const RTM_AUTHOR_COURSEWARE_PROJECT_FIND_ERROR = 'author.courseware.project.find.error';

// API Layer constants for scope
export const RTM_AUTHOR_SOURCE_SCOPE_LIST = 'author.source.scope.list';
export const RTM_AUTHOR_SOURCE_SCOPE_LIST_OK = 'author.source.scope.list.ok';
export const RTM_AUTHOR_SOURCE_SCOPE_LIST_ERROR = 'author.source.scope.list.error';

// API layer constants for templates
export const RTM_AUTHOR_TEMPLATE_CREATE = 'author.template.create';
export const RTM_AUTHOR_TEMPLATE_CREATE_OK = 'author.template.create.ok';
export const RTM_AUTHOR_TEMPLATE_CREATE_ERROR = 'author.template.create.error';

export const RTM_AUTHOR_TEMPLATE_UPDATE = 'author.template.update';
export const RTM_AUTHOR_TEMPLATE_UPDATE_OK = 'author.template.update.ok';
export const RTM_AUTHOR_TEMPLATE_UPDATE_ERROR = 'author.template.update.error';

export const RTM_AUTHOR_TEMPLATE_LIST = 'author.template.list';
export const RTM_AUTHOR_TEMPLATE_LIST_OK = 'author.template.list.ok';
export const RTM_AUTHOR_TEMPLATE_LIST_ERROR = 'author.template.list.error';

export const RTM_AUTHOR_TEMPLATE_GET = 'author.template.get';
export const RTM_AUTHOR_TEMPLATE_GET_OK = 'author.template.get.ok';
export const RTM_AUTHOR_TEMPLATE_GET_ERROR = 'author.template.get.error';

export const RTM_AUTHOR_TEMPLATES_FILTER = 'author.templates.filter';
export const RTM_AUTHOR_TEMPLATES_FILTER_OK = 'author.templates.filter.ok';
export const RTM_AUTHOR_TEMPLATES_FILTER_ERROR = 'author.templates.filter.error';

export const RTM_AUTHOR_TEMPLATES_FILTER_TYPE = 'author.templates.filter.type';
export const RTM_AUTHOR_TEMPLATES_FILTER_TYPE_OK = 'author.templates.filter.type.ok';
export const RTM_AUTHOR_TEMPLATES_FILTER_TYPE_ERROR = 'author.templates.filter.type.error';

export const RTM_AUTHOR_TEMPLATE_DELETE = 'author.template.delete';
export const RTM_AUTHOR_TEMPLATE_DELETE_OK = 'author.template.delete.ok';
export const RTM_AUTHOR_TEMPLATE_DELETE_ERROR = 'author.template.delete.error';

export const RTM_AUTHOR_THEME_LIST = 'author.theme.list';
export const RTM_AUTHOR_THEME_LIST_OK = 'author.theme.list.ok';
export const RTM_AUTHOR_THEME_LIST_ERROR = 'author.theme.list.error';

export const RTM_WORKSPACE_THEME_GET = 'workspace.theme.get';
export const RTM_WORKSPACE_THEME_GET_OK = 'workspace.theme.get.ok';
export const RTM_WORKSPACE_THEME_GET_ERROR = 'workspace.theme.get.error';

export const RTM_AUTHOR_THEME_CREATE = 'author.theme.create';
export const RTM_AUTHOR_THEME_CREATE_OK = 'author.theme.create.ok';
export const RTM_AUTHOR_THEME_CREATE_ERROR = 'author.theme.create.error';

export const RTM_AUTHOR_THEME_UPDATE = 'author.theme.update';
export const RTM_AUTHOR_THEME_UPDATE_OK = 'author.theme.update.ok';
export const RTM_AUTHOR_THEME_UPDATE_ERROR = 'author.theme.update.error';

export const RTM_AUTHOR_THEME_DELETE = 'author.theme.delete';
export const RTM_AUTHOR_THEME_DELETE_OK = 'author.theme.delete.ok';
export const RTM_AUTHOR_THEME_DELETE_ERROR = 'author.theme.delete.error';

export const RTM_AUTHOR_THEME_VARIANT_GET = 'author.theme.variant.get';
export const RTM_AUTHOR_THEME_VARIANT_GET_OK = 'author.theme.variant.get.ok';
export const RTM_AUTHOR_THEME_VARIANT_GET_ERROR = 'author.theme.variant.get.error';

export const RTM_AUTHOR_THEME_VARIANT_CREATE = 'author.theme.variant.create';
export const RTM_AUTHOR_THEME_VARIANT_CREATE_OK = 'author.theme.variant.create.ok';
export const RTM_AUTHOR_THEME_VARIANT_CREATE_ERROR = 'author.theme.variant.create.error';

export const RTM_AUTHOR_THEME_VARIANT_UPDATE = 'author.theme.variant.update';
export const RTM_AUTHOR_THEME_VARIANT_UPDATE_OK = 'author.theme.variant.update.ok';
export const RTM_AUTHOR_THEME_VARIANT_UPDATE_ERROR = 'author.theme.variant.update.error';

export const RTM_AUTHOR_THEME_VARIANT_DELETE = 'author.theme.variant.delete';
export const RTM_AUTHOR_THEME_VARIANT_DELETE_OK = 'author.theme.variant.delete.ok';
export const RTM_AUTHOR_THEME_VARIANT_DELETE_ERROR = 'author.theme.variant.delete.error';

export const RTM_AUTHOR_ELEMENT_THEME_CREATE = 'author.element.theme.create';
export const RTM_AUTHOR_ELEMENT_THEME_CREATE_OK = 'author.element.theme.create.ok';
export const RTM_AUTHOR_ELEMENT_THEME_CREATE_ERROR = 'author.element.theme.create.error';

export const RTM_AUTHOR_ELEMENT_THEME_DELETE = 'author.element.theme.delete';
export const RTM_AUTHOR_ELEMENT_THEME_DELETE_OK = 'author.element.theme.delete.ok';
export const RTM_AUTHOR_ELEMENT_THEME_DELETE_ERROR = 'author.element.theme.delete.error';

export const RTM_AUTHOR_THEME_COLLABORATOR_SUMMARY = 'author.theme.collaborator.summary';
export const RTM_AUTHOR_THEME_COLLABORATOR_SUMMARY_OK = 'author.theme.collaborator.summary.ok';
export const RTM_AUTHOR_THEME_COLLABORATOR_SUMMARY_ERROR = 'author.theme.collaborator.summary.error';

export const RTM_THEME_PERMISSION_GRANT = 'theme.permission.grant';
export const RTM_THEME_PERMISSION_GRANT_OK = 'theme.permission.grant.ok';
export const RTM_THEME_PERMISSION_GRANT_ERROR = 'theme.permission.grant.error';

export const RTM_THEME_PERMISSION_REVOKE = 'theme.permission.revoke';
export const RTM_THEME_PERMISSION_REVOKE_OK = 'theme.permission.revoke.ok';
export const RTM_THEME_PERMISSION_REVOKE_ERROR = 'theme.permission.revoke.error';

export const RTM_PUBLICATION_CREATE_REQUEST = 'publication.create.request';
export const RTM_PUBLICATION_CREATE_REQUEST_OK = 'publication.create.request.ok';
export const RTM_PUBLICATION_CREATE_REQUEST_ERROR = 'publication.create.request.error';

export const RTM_PUBLICATION_HISTORY_FETCH = 'publication.history.fetch';
export const RTM_PUBLICATION_HISTORY_FETCH_OK = 'publication.history.fetch.ok';
export const RTM_PUBLICATION_HISTORY_FETCH_ERROR = 'publication.history.fetch.error';

export const RTM_PUBLICATION_TITLE_UPDATE = 'publication.title.update.request';
export const RTM_PUBLICATION_TITLE_UPDATE_OK = 'publication.title.update.request.ok';
export const RTM_PUBLICATION_TITLE_UPDATE_ERROR = 'publication.title.update.request.error';

export const RTM_PUBLICATION_HISTORY_DELETE = 'publication.history.delete';
export const RTM_PUBLICATION_HISTORY_DELETE_OK = 'publication.history.delete.ok';
export const RTM_PUBLICATION_HISTORY_DELETE_ERROR = 'publication.history.delete.error';

export const RTM_PUBLICATION_JOB_SUBSCRIBE = 'publication.job.subscribe';
export const RTM_PUBLICATION_JOB_SUBSCRIBE_OK = 'publication.job.subscribe.ok';
export const RTM_PUBLICATION_JOB_SUBSCRIBE_ERROR = 'publication.job.subscribe.error';

export const RTM_PUBLICATION_JOB_UNSUBSCRIBE = 'publication.job.unsubscribe';
export const RTM_PUBLICATION_JOB_UNSUBSCRIBE_OK = 'publication.job.unsubscribe.ok';
export const RTM_PUBLICATION_JOB_UNSUBSCRIBE_ERROR = 'publication.job.unsubscribe.error';

export const RTM_PUBLICATION_OCULUS_STATUS = 'publication.oculus.status';
export const RTM_PUBLICATION_OCULUS_STATUS_OK = 'publication.oculus.status.ok';
export const RTM_PUBLICATION_OCULUS_STATUS_ERROR = 'publication.oculus.status.error';

export const RTM_PUBLICATION_VERSION_DIFF = 'publication.version.diff';
export const RTM_PUBLICATION_VERSION_DIFF_OK = 'publication.version.diff.ok';
export const RTM_PUBLICATION_VERSION_DIFF_ERROR = 'publication.version.diff.error';

export const RTM_AUTHOR_ACCOUNT_SUMMARY_LIST = 'author.account.summary.list';
export const RTM_AUTHOR_ACCOUNT_SUMMARY_LIST_OK = 'author.account.summary.list.ok';
export const RTM_AUTHOR_ACCOUNT_SUMMARY_LIST_ERROR = 'author.account.summary.list.error';

export const RTM_PROVISION_EXTERNAL_USER = 'iam.subscription.user.provision';
export const RTM_PROVISION_EXTERNAL_USER_OK = 'iam.subscription.user.provision.ok';
export const RTM_PROVISION_EXTERNAL_USER_ERROR = 'iam.subscription.user.provision.error';

export const RTM_WORKSPACE_COMPETENCY_COLLABORATOR_SUMMARY = 'workspace.competency.collaborator.summary';
export const RTM_WORKSPACE_COMPETENCY_COLLABORATOR_SUMMARY_OK = 'workspace.competency.collaborator.summary.ok';
export const RTM_WORKSPACE_COMPETENCY_COLLABORATOR_SUMMARY_ERROR = 'workspace.competency.collaborator.summary.error';

export const RTM_WORKSPACE_COMPETENCY_PERMISSION_GRANT = 'workspace.competency.permission.grant';
export const RTM_WORKSPACE_COMPETENCY_PERMISSION_GRANT_OK = 'workspace.competency.permission.grant.ok';
export const RTM_WORKSPACE_COMPETENCY_PERMISSION_GRANT_ERROR = 'workspace.competency.permission.grant.error';

export const RTM_WORKSPACE_COMPETENCY_PERMISSION_REVOKE = 'workspace.competency.permission.revoke';
export const RTM_WORKSPACE_COMPETENCY_PERMISSION_REVOKE_OK = 'workspace.competency.permission.revoke.ok';
export const RTM_WORKSPACE_COMPETENCY_PERMISSION_REVOKE_ERROR = 'workspace.competency.permission.revoke.error';

export const RTM_PUBLICATION_PEARSON_PLUS_REPUBLISH_REQUEST = 'publication.pearsonplus.republish.request';
export const RTM_PUBLICATION_PEARSON_PLUS_REPUBLISH_REQUEST_OK = 'publication.pearsonplus.republish.request.ok';
export const RTM_PUBLICATION_PEARSON_PLUS_REPUBLISH_REQUEST_ERROR = 'publication.pearsonplus.republish.request.error';

export const RTM_PRODUCTID_VALIDATION_REQUEST = 'productid.validation.request';
export const RTM_PRODUCTID_VALIDATION_REQUEST_OK = 'productid.validation.request.ok';
export const RTM_PRODUCTID_VALIDATION_REQUEST_ERROR = 'productid.validation.request.error';

export const RTM_PDZ_PRODUCTID_VALIDATION_REQUEST = 'productid.validation.pdz.request';
export const RTM_PDZ_PRODUCTID_VALIDATION_REQUEST_OK = 'productid.validation.pdz.request.ok';
export const RTM_PDZ_PRODUCTID_VALIDATION_REQUEST_ERROR = 'productid.validation.pdz.request.error';

export const RTM_PUBLICATION_PEARSON_PLUS_TEST_PUBLISH_REQUEST = 'publication.pearsonplus.test.publish.request';
export const RTM_PUBLICATION_PEARSON_PLUS_TEST_PUBLISH_REQUEST_OK = 'publication.pearsonplus.test.publish.request.ok';
export const RTM_PUBLICATION_PEARSON_PLUS_TEST_PUBLISH_REQUEST_ERROR = 'publication.pearsonplus.test.publish.request.error';

export const RTM_PUBLICATION_PEARSON_PLUS_TEST_REPUBLISH_REQUEST = 'publication.pearsonplus.test.republish.request';
export const RTM_PUBLICATION_PEARSON_PLUS_TEST_REPUBLISH_REQUEST_OK = 'publication.pearsonplus.test.republish.request.ok';
export const RTM_PUBLICATION_PEARSON_PLUS_TEST_REPUBLISH_REQUEST_ERROR = 'publication.pearsonplus.test.republish.request.error';

export const RTM_WORKSPACE_COHORT_ISONDEMAND = 'workspace.cohort.isondemand';
export const RTM_WORKSPACE_COHORT_ISONDEMAND_OK = 'workspace.cohort.isondemand.ok';
export const RTM_WORKSPACE_COHORT_ISONDEMAND_ERROR = 'workspace.cohort.isondemand.error';

export const RTM_AUTHOR_SUMMARY_SNS = 'author.summary.sns';
export const RTM_AUTHOR_SUMMARY_SNS_OK = 'author.summary.sns.ok';
export const RTM_AUTHOR_SUMMARY_SNS_ERROR = 'author.summary.sns.error';

export const RTM_AUTHOR_SUMMARY_SNS_SUBSCRIBE = 'author.summary.subscribe';
export const RTM_AUTHOR_SUMMARY_SNS_SUBSCRIBE_OK = 'author.summary.subscribe.ok';
export const RTM_AUTHOR_SUMMARY_SNS_SUBSCRIBE_ERROR = 'author.summary.subscribe.error';

export const RTM_AUTHOR_SUMMARY_SNS_UNSUBSCRIBE = 'author.summary.unsubscribe';
export const RTM_AUTHOR_SUMMARY_SNS_UNSUBSCRIBE_OK = 'author.summary.unsubscribe.ok';
export const RTM_AUTHOR_SUMMARY_SNS_UNSUBSCRIBE_ERROR = 'author.summary.unsubscribe.error';

// Error constants for AI Summary service
export const UNKNOWN_ERROR_CODE = 'UNKNOWN_ERROR';
export const UNEXPECTED_ERROR_MESSAGE = 'An unexpected error occurred';

export const RTM_WORKSPACE_DEPLOYMENT_DETAILS = 'workspace.deployment.details';
export const RTM_WORKSPACE_DEPLOYMENT_DETAILS_OK = 'workspace.deployment.details.ok';
export const RTM_WORKSPACE_DEPLOYMENT_DETAILS_ERROR = 'workspace.deployment.details.error';

export const RTM_WORKSPACE_LIBRARY_LIST = 'workspace.library.list';
export const RTM_WORKSPACE_LIBRARY_LIST_OK = 'workspace.library.list.ok';
export const RTM_WORKSPACE_LIBRARY_LIST_ERROR = 'workspace.library.list.error';

// Constants for Search
export const RTM_AUTHOR_SEARCH = 'author.search';
export const RTM_AUTHOR_SEARCH_OK = 'author.search.ok';
export const RTM_AUTHOR_SEARCH_ERROR = 'author.search.error';

export const RTM_AUTHOR_SEARCH_SUGGEST = 'author.search.suggest';
export const RTM_AUTHOR_SEARCH_SUGGEST_OK = 'author.search.suggest.ok';
export const RTM_AUTHOR_SEARCH_SUGGEST_ERROR = 'author.search.suggest.error';

// BACW-554 — trigger backend indexing for an existing/imported course.
// Verb names verified against bronte-service-mercury IndexActivityMessageHandler.java
// (handler bound in WorkspaceRTMOperationsBinding; AllowAuthenticated + AllowWorkspaceRoles).
export const RTM_PROJECT_ACTIVITY_INDEX = 'project.activity.index';
export const RTM_PROJECT_ACTIVITY_INDEX_OK = 'project.activity.index.ok';
export const RTM_PROJECT_ACTIVITY_INDEX_ERROR = 'project.activity.index.error';

// BACW-840 — query indexing status for a course (returns IndexStatus enum:
// NONE | INPROGRESS | COMPLETED | ERROR | INDEX_IN_PROGRESS).
export const RTM_PROJECT_ACTIVITY_INDEX_STATUS = 'project.activity.index.status';
export const RTM_PROJECT_ACTIVITY_INDEX_STATUS_OK = 'project.activity.index.status.ok';
export const RTM_PROJECT_ACTIVITY_INDEX_STATUS_ERROR = 'project.activity.index.status.error';
